<template>
  <!-- 应收对账单列表 -->
  <div class="container">
    <!-- 按钮列表 -->
    <div class="glo_btnList" ref="btnList">
      <div class="glo_btnList_left">
        <el-button
            class="glo_btnItems glo_bgcMainColor"
            @click="onReceivableBillListDetails('create')"

          >新建</el-button
        >
        <el-button
            class="glo_btnItems glo_bgcMainColor"
            @click="onReceivableBillListDetails('modify')"

          >修改</el-button
        >
        <el-button
            class="glo_btnItems glo_bgcMainColor"
            @click="onCustomerStatement()"

          >对账确认</el-button
        >
        <el-button
            class="glo_btnItems glo_bgcMainColor"
            @click="onCancelCustomerStatement()"

          >取消对账</el-button
        >
        <el-button
            class="glo_btnItems glo_bgcMainColor"
            @click="onDelStatement()"

          >删除对账单</el-button
        >
        <el-button
            class="glo_btnItems glo_bgcMainColor"
            @click="onApproveryStatement()"

          >审核对账单</el-button
        >
        <el-button
            class="glo_btnItems glo_bgcMainColor"
            @click="onReapproveryStatement()"

          >反审核对账单</el-button
        >
      </div>
      <queryBtns
        :MoreConditions="MoreConditions"
        @clerBtns="clerBtns"
        @queryBtn_ok="queryBtn_ok"
        @moreParam="moreParam"
      ></queryBtns>
    </div>
    <!-- 查询条件 -->
    <!-- :formData="queryData" -->
    <queryCondition
      ref="queryForm"
      :More="isHaseMore"
      :formConfig="queryCondditionDatas"
    ></queryCondition>
    <!-- 表格 -->
    <div class="glo_Table">
      <el-table
        :height="tableHeigth"
        header-align="center"
        ref="mytable"
        @row-click="rowclick"
        :data="tableData"
        border
        stripe
        :highlight-current-row="true"
        show-summary
        :summary-method="getSummaries"
        @selection-change="handleSelectionChange"
      >
        <el-table-column
          fixed="left"
          align="center"
          label="序号"
          type="index"
          width="60"
        ></el-table-column>
        <el-table-column
          fixed="left"
          align="center"
          type="selection"
          width="60"
        ></el-table-column>
        <template v-for="(item, index) in myTableHeard">
          <!-- 某个字段需要单独操作  例如点击可以跳转 -->
          <el-table-column
            v-if="item.field === 'aaaaaaaaaa' && item.isShow"
            :key="index"
            :label="item.name"
            :prop="item.field"
            align="left"
            sortable
            :show-overflow-tooltip="true"
            :min-width="item.width"
            :data-isTotal="item.isTotal"
          >
            <template slot-scope="scope">
              <div class="linkTabel">
                {{ scope.row.aaaaaaaaaa }}
              </div>
            </template>
          </el-table-column>
          <el-table-column
            :key="index"
            :label="item.name"
            :prop="item.field"
            align="center"
            sortable
            :show-overflow-tooltip="true"
            :min-width="item.width"
            :data-isTotal="item.isTotal"
            v-else-if="item && item.isShow"
          ></el-table-column>
        </template>
        
      </el-table>
    </div>

    <!-- 分页 -->
    <paging
      ref="pags"
      :pageNum="pageStart"
      :total="pageCount"
      :size="pageTotal"
      @handleSizeChange="handleSizeChange"
      @handleCurrentChange="handleCurrentChange"
    ></paging>

    <!--        自定义表头           -->
    <!-- <sorttable
        :show_sortTableHeard="show_sortTableHeard"
        :allCheck="allCheck"
        :sortName="sortName"
        :tabelHeadeTitle="tabelHeadeTitle"
        :originalTabelHeadeTitle="originalTabelHeadeTitle"
        :selectLength="selectLength"
        @cancelSortHeard="cancelSortHeard"
        @confirmOk="confirmOk"
        @checktab="checktab"
        @checkAll="checkAll"
        @closeDias="closeDias"
      ></sorttable> -->

    <!-- 导出插件 -->
    <!-- <exportCompoent
      :isShowDialog_dc="isShowDialog_dc"
      :diaWidth_dc="diaWidth_dc"
      :dialogTitle_dc="dialogTitle_dc"
      :dialogForm_dc="dialogForm_dc"
      :tableHeard="EPtableHeard"
      :AllCheck="EPAllCheck"
      :queryCondditionDatas="queryCondditionDatas"
      @checktabEP="checktabEP"
      @checkAllEP="checkAllEP"
      @onAfterEnter="onAfterEnter"
      @handleCloseDia_dc="handleCloseDia_dc"
      @diaConfirmBtn_dc="diaConfirmBtn_dc()"
    >
    </exportCompoent> -->

  </div>
</template>
  <script>
import tableList from "@/pages/DynamicList/tableList.js";
//   import sorttable from "@/components/sortTemplate.vue"; //自定义排序表头
import paging from "@/components/pagings.vue"; //分页组件
import queryBtns from "@/components/queryBtnsDT.vue";
import queryCondition from "@/components/queryCondition.vue";
import myDialog from "@/components/DialogDT.vue";
import { Message as ElMessage, MessageBox as ElMessageBox } from 'element-ui'
import utils from "@/assets/js/tool";
//   import exportjs from "@/assets/js/Mixins/exportDT.js"; //导出的公共js
import customerModelService from "@/components/customerService/modelIndex.vue";
import { Api } from "@/assets/js/api";
import commonFuJian from "@/components/fuJian/index.vue";

export default {
  mixins: [tableList],
  inject: ["reload"],
  components: {
    commonFuJian,
    //   sorttable,
    paging,
    queryBtns,
    queryCondition,
    myDialog,
    customerModelService,
  },
  data() {
    return {
      userList: [],

      //=======================导出相关 开始 =======================
      dialogForm_dc: {
        pageStart: 1,
        pageTotal: "",
        fileName: "应收对账单列表", //导出时默认文件名
        apiName: "/v1/common/query/runPageReport", //导出的数据列表接口名(动态列表都是这个)
        EpType: "bdd", //dd===等待下载完成,bdd===不等待完成
        apiType: "POST", //导出当前列表的请求方式
        isJson: 1, // 导出当前列表的请求头是否json
      },
      //=======================导出相关 结束 =======================
      pageGroupName: "DynamicListFinanceInStatementList", //  页面标识
      reportFiledsNumber: "admin_finance_in_statement_list", // 动态 条件、表头

      currentItemArr: [],
      cancel: false,
    };
  },
  mounted() {},
  watch: {},
  created() {
  },
  methods: {
    // 表格选择事件
    handleSelectionChange(e) {
      this.currentItemArr = e || [];
    },

    // 不能输入负数
    minNum(val) {
      return val < 0 ? 0 : val;
    },

    onReceivableBillListDetails(status, rowData){
      if (status == "create") {
        let obj = {
          status: "create",
          financeType: "finance_record_group",
          cache: false,
        };
        this.$router.push({
          path: "/pages/v4/finance/cenerateStatement",
          query: obj,
        });
      } else if (status == "modify") {
        let list = this.currentItemArr || [];
        if (rowData) {
          list = [rowData];
        }
        if (list.length == 1) {
          sessionStorage.setItem("clearReceivableManagementReceivableBillEdit", 1);
          let obj = {
            status: "modify",
            statementId: list[0]["statementId"],
          };
          this.$router.push({
            path: "/pages/v4/finance/receivableBillEdit",
            query: obj,
          });
        } else {
          ElMessage({
            message: "请选择1条表格数据",
            type: "warning",
          });
        }
      }else if (status == "writeoff") {
        // 核销
        let list = this.currentItemArr || [];
        if (rowData) {
          list = [rowData];
        }
        if (list.length == 1) {
          sessionStorage.setItem("clearReceivableManagementReceivableBillEdit", 1);
          let obj = {
            status: "writeoff",
            statementId: list[0]["statementId"],
          };
          this.$router.push({
            path: "/receivableManagement/receivableBillWriteOff",
            query: obj,
          });
        } else {
          ElMessage({
            message: "请选择1条表格数据",
            type: "warning",
          });
        }
      }
    },

    onCustomerStatement(row){
      let ids = [];
      if (row) {
        const rowData = row.row;
        console.log("rowData", rowData);
        ids = [rowData.statementId];
      } else {
        if (this.currentItemArr.length < 1) {
          ElMessage({
            message: "请选择需要对账确认的单据",
            type: "warning",
          });
          return false;
        }
        ids = this.currentItemArr.map((item) => {
          return item.statementId;
        });
      }
      ElMessageBox.confirm("确认对该数据进行 对账确认 操作？", "系统提示", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {

        let obj = {
          statementIds: ids,
        };
        Api.customerStatement(obj).then((res) => {
          if (res.status === 200) {
            const data = res.data;
            if (utils.jyCheckObjectType(data) === "Object") {
              ElMessage({
                message: data.message,
                type: data.status,
              });
              if("success"===data.status){
                let that = this;
                setTimeout(() => {
                  that.queryBtn_ok();
                }, 500);
              }
            }
          }
        });
      });
    },
    onCancelCustomerStatement(row){
      let ids = [];
      if (row) {
        const rowData = row.row;
        console.log("rowData", rowData);
        ids = [rowData.statementId];
      } else {
        if (this.currentItemArr.length < 1) {
          ElMessage({
            message: "请选择需要取消对账的单据",
            type: "warning",
          });
          return false;
        }
        ids = this.currentItemArr.map((item) => {
          return item.statementId;
        });
      }
      ElMessageBox.confirm("确认对该数据进行 取消对账 操作？", "系统提示", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {

        let obj = {
          statementIds: ids,
        };
        Api.cancelCustomerStatement(obj).then((res) => {
          if (res.status === 200) {
            const data = res.data;
            if (utils.jyCheckObjectType(data) === "Object") {
              ElMessage({
                message: data.message,
                type: data.status,
              });
              if("success"===data.status){
                let that = this;
                setTimeout(() => {
                  that.queryBtn_ok();
                }, 500);
              }
            }
          }
        });
      });
    },
    onDelStatement(row){
      let ids = [];
      if (row) {
        const rowData = row.row;
        console.log("rowData", rowData);
        ids = [rowData.statementId];
      } else {
        if (this.currentItemArr.length < 1) {
          ElMessage({
            message: "请选择需要删除的单据",
            type: "warning",
          });
          return false;
        }
        ids = this.currentItemArr.map((item) => {
          return item.statementId;
        });
      }
      ElMessageBox.confirm("确认对该数据进行 删除 操作？", "系统提示", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {

        let obj = {
          statementIds: ids,
        };
        Api.delStatement(obj).then((res) => {
          if (res.status === 200) {
            const data = res.data;
            if (utils.jyCheckObjectType(data) === "Object") {
              ElMessage({
                message: data.message,
                type: data.status,
              });
              if("success"===data.status){
                let that = this;
                setTimeout(() => {
                  that.queryBtn_ok();
                }, 500);
              }
            }
          }
        });
      });
    },
    onApproveryStatement(row){
      let ids = [];
      if (row) {
        const rowData = row.row;
        console.log("rowData", rowData);
        ids = [rowData.statementId];
      } else {
        if (this.currentItemArr.length < 1) {
          ElMessage({
            message: "请选择需要审核的单据",
            type: "warning",
          });
          return false;
        }
        ids = this.currentItemArr.map((item) => {
          return item.statementId;
        });
      }
      ElMessageBox.confirm("确认对该数据进行 审核 操作？", "系统提示", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {

        let obj = {
          statementIds: ids,
        };
        Api.approveryStatement(obj).then((res) => {
          if (res.status === 200) {
            const data = res.data;
            if (utils.jyCheckObjectType(data) === "Object") {
              ElMessage({
                message: data.message,
                type: data.status,
              });
              if("success"===data.status){
                let that = this;
                setTimeout(() => {
                  that.queryBtn_ok();
                }, 500);
              }
            }
          }
        });
      });
    },
    onReapproveryStatement(row){
      let ids = [];
      if (row) {
        const rowData = row.row;
        console.log("rowData", rowData);
        ids = [rowData.statementId];
      } else {
        if (this.currentItemArr.length < 1) {
          ElMessage({
            message: "请选择需要取消审核的单据",
            type: "warning",
          });
          return false;
        }
        ids = this.currentItemArr.map((item) => {
          return item.statementId;
        });
      }
      ElMessageBox.confirm("确认对该数据进行 取消 操作？", "系统提示", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {

        let obj = {
          statementIds: ids,
        };
        Api.reapproveryStatement(obj).then((res) => {
          if (res.status === 200) {
            const data = res.data;
            if (utils.jyCheckObjectType(data) === "Object") {
              ElMessage({
                message: data.message,
                type: data.status,
              });
              if("success"===data.status){
                let that = this;
                setTimeout(() => {
                  that.queryBtn_ok();
                }, 500);
              }
            }
          }
        });
      });
    },

  },
};
</script>
  <style scoped lang="scss">
::v-deep .el-date-editor.el-input {
  width: auto !important;
}

.classA {
  display: flex;
}

.glo_dialogForm .diaForm .dialogFormItems {
  height: 30px !important;
  line-height: 30px !important;
  overflow: hidden;
}

.couponBox {
  width: 100%;
  margin-bottom: 20px;
  height: 34px;

  .couponitmeInput {
    width: 100px;
    border: 1px solid #cccccc;
    margin: 0 6px;

    ::v-deep .el-input__inner {
      height: 30px;
      line-height: 30px;
    }
  }

  .couponItemA {
    display: flex;
    align-items: center;
  }
}

.displays {
  display: flex;
  align-items: center;
  justify-content: space-around;
}

.rows {
  display: flex;
  width: 100%;
}

.multipleSelect {
  ::v-deep .el-select {
    border: 1px solid #cccccc;
    border-radius: 4px;
  }
}
</style>
  